<template>
  <div class="contact-us">
    <div class="top jumbotron jumbotron-fluid mb-2">
      <div class="container">
        <h1 class="animated fadeInDown">联系我们</h1>
        <p class="animated fadeInDown">—— 能为您服务是我们的荣幸 ——</p>
      </div>
    </div>
    <div class="content"></div>
  </div>
</template>

<!--suppress ES6CheckImport -->
<script>
import { WOW } from "wowjs";

export default {
  name: "ContactUs",
  mounted() {
    let options = {
      //默认为true
      live: false
    };
    new WOW().init(options);
  }
};
</script>

<style scoped lang="scss">
.contact-us {
  margin-top: 67px;

  .top {
    width: 100%;
    background-size: cover;
    color: #ff4f02;
  }
  .content {
    min-height: 500px;
  }
}
</style>
